import { render, staticRenderFns } from "./activity_details.vue?vue&type=template&id=487151b2&scoped=true"
import script from "./activity_details.vue?vue&type=script&lang=js"
export * from "./activity_details.vue?vue&type=script&lang=js"
import style0 from "./activity_details.vue?vue&type=style&index=0&id=487151b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487151b2",
  null
  
)

export default component.exports